import { create, test, enforce, only, skipWhen, warn, omitWhen, include } from "vest";
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)



enforce.extend({
    isDMY(v) {
        return dayjs(v, 'DD.MM.YYYY', true).isValid()
    },
    condi(v, func) {
        let ret= func(v) ? true : false
//console.log('condi v ret func', v, ret, func)        
        return ret
    }
})    


const suite_func = (data = {}, currentField) => {
    let onar = [currentField]

    if ( ['doc_gra', 'doc_type'].includes(currentField) ) {
        onar = [
            "doc_gra",
            "doc_type", 
                'doc_serie', 'doc_number', "doc_valid", "doc_issue", "doc_unitcode", "doc_authority",
                "fname", "iname", "oname", "flname", "ilname",
        ]
    } else if (
        [
            "doc_serie", "doc_number", "doc_valid", "doc_issue", "doc_unitcode", "doc_authority",
            "fname", "iname", "oname", "flname", "ilname"
        ].includes(currentField)
    ) {
        onar = ["doc_gra", "doc_type", currentField]
    }

    only(onar)  // include появилось только в четвертой версии

    test('male', "Заполните поле", () => {
        enforce(data.male).longerThanOrEquals(1);
    });

    test('born', "Введите дату в формате DD.MM.YYYY", ()=>{
        enforce(data.born).isDMY();
    });

    test('doc_issue', "Введите дату в формате DD.MM.YYYY", ()=>{
        enforce(data.doc_issue).isDMY();
    });

    test('doc_valid', "Введите дату в формате DD.MM.YYYY", ()=>{
        enforce(data.doc_valid).condi(s => {
            return !['zps', 'other'].includes( data.doc_type) || dayjs(s, 'DD.MM.YYYY', true).isValid()
        })
    });


    test('doc_gra', "Заполните поле", () => {
        enforce(data.doc_gra).longerThanOrEquals(1);
    });


    test('doc_type', "Заполните поле", () => {
        enforce(data.doc_type).longerThanOrEquals(1);
    });


    omitWhen( data.isCust, () => {
        test('doc_type', `Допустим только иной документ`, () => {
            enforce(data.doc_type).condi(s=>{
                return 'RU' !== data.doc_gra && 'other' !== s  ? false : true
            })
        });
    })

    // серия
    test('doc_serie', "Заполните поле", () => {
        enforce(data.doc_serie).longerThanOrEquals(1);
    });
    test('doc_serie', "9999", () => {
        enforce(data.doc_serie).condi(s => {
            return  data.doc_type !== 'ps' || s.match(/^\d{4}$/)
        })
    });
    test('doc_serie', "99", () => {
        enforce(data.doc_serie).condi(s => {
            return  data.doc_type !== 'zps' || s.match(/^\d{2}$/)
        })
    });
    test('doc_serie', "3-8 букв", () => {
        enforce(data.doc_serie).condi(s=>{
            return data.doc_type !== 'svr' || s.match(/^[-АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯIVX]{3,8}$/) ? true : false
        })
    });
    test('doc_serie', "1-4 букв или цифр", () => {
        enforce(data.doc_serie).condi(s=>{
            return data.doc_type !== 'other' || s.match(/^[-АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯA-Z0-9]{1,4}$/) ? true : false
        })
    });

    // номер
    test('doc_number', "Заполните поле", () => {
        enforce(data.doc_number).longerThanOrEquals(1);
    });
    test('doc_number', "999999", () => {
        enforce(data.doc_number).condi(s=>{
            return data.doc_type !== 'ps' || s.match(/^\d{6}$/) ? true : false
        })
    });
    test('doc_number', "9999999", () => {
        enforce(data.doc_number).condi(s=>{
            return data.doc_type !== 'zps' || s.match(/^\d{7}$/) ? true : false
        })
    });
    test('doc_number', "999999", () => {
        enforce(data.doc_number).condi(s=>{
            return data.doc_type !== 'svr' || s.match(/^\d{6}$/) ? true : false
        })
    });
    test('doc_number', "1-10 латинских букв или цифр", () => {
        enforce(data.doc_number).condi(s=>{
            return data.doc_type !== 'other' || s.match(/^[A-Z0-9]{1,10}$/) ? true : false
        })
    });


    omitWhen( !(data.doc_gra === 'RU'), () => {    
        let hz=[ 'fname', 'iname', 'oname' ].forEach(ff => {
            let val= data[ ff ]

            test(ff, "Минимум 2 буквы", () => {
                enforce(val).longerThanOrEquals(2);
            });

            test(ff, "Максимум 61 буква", () => {
                enforce(val).shorterThanOrEquals(61);
            });

            test(ff, "Проверьте что только русские буквы дефис или пробел", () => {
                enforce(val).notMatches(/[^АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ -]/);
            });

        })
    })

    omitWhen( !('RU' !== data.doc_gra || 'zps' === data.doc_type ) , () => {
        let hz1=[ 'flname', 'ilname' ].forEach(ff => {
            let val= data[ ff ]

            test(ff, "Минимум 2 буквы", () => {
                enforce(val).longerThanOrEquals(2);
            });

            test(ff, "Максимум 61 буква", () => {
                enforce(val).shorterThanOrEquals(61);
            });

            test(ff, "Проверьте что только латинские буквы дефис или пробел", () => {
                enforce(val).notMatches(/[^A-Z -]/);
            });

        })
    })

    omitWhen( !(data.isCust && 'RU' === data.doc_gra && 'ps' === data.doc_type ) , () => {
        test('doc_unitcode', "Заполните поле", () => {// doc_address doc_unitcode doc_authority
            enforce(data.doc_unitcode).longerThanOrEquals(1);
        })
        test('doc_unitcode', "123-456", () => {
            enforce(data.doc_unitcode).matches(/^\d{6}$/)
        });

        test('doc_authority', "Заполните поле", () => {// doc_address doc_unitcode doc_authority
            enforce(data.doc_authority).longerThanOrEquals(1);
        })
    })


    omitWhen( !data.isCust, () => {


        test('doc_type', "Допустим только российский паспорт", () => {
            enforce(data.doc_type).condi(s=>{
                return 'RU' === data.doc_gra && 'ps' !== s  ? false : true
            })
        });
        test('doc_type', "Допустим только иной документ", () => {
            enforce(data.doc_type).condi(s=>{
                return 'RU' !== data.doc_gra && 'other' !== s  ? false : true
            })
        });


        test('doc_address', "Заполните поле", () => {// doc_address doc_unitcode doc_authority
            enforce(data.doc_address).longerThanOrEquals(1);
        })

        test('doc_zip', "Заполните поле", () => {// doc_address doc_unitcode doc_authority
            enforce(data.doc_zip).longerThanOrEquals(1);
        })
        test('doc_zip', "999999", () => {
            enforce(data.doc_zip).matches(/^\d{6}$/)
        });


        test('email', "Заполните поле", () => {
            enforce(data.email).longerThanOrEquals(1);
        })
        test('email', "Проверьте что только латинские буквы, цифры и символы  \".\", \"_\", \"-\", \"+\"", () => {
            enforce(data.email).matches(/^[a-z0-9_\-\.\+]+@[a-z0-9_\-\.]+$/)
        })


        test('phone', "Заполните поле", () => {
            enforce(data.phone).longerThanOrEquals(1);
        })
        test('phone', "Проверьте", () => {
            enforce(data.phone).matches(/^\+7\d{10}$/) || v.match(/^\+[0-689]\d{8,14}$/)
        })
        

    })


}


const suite_cache = {}
export const suite_tourist = sid => {
    return suite_cache[sid]
}

export const suite_init = (sid, tip = 'tourist') => {
    if (sid in suite_cache) {
    } else {
        suite_cache[sid] = create( suite_func )
    }
}

export const suite_remove = sid => {
    delete suite_cache[ sid ]
}

export const suite_set = (sid, ff, val) => {
    let suite = suite_tourist(sid)
    let ob={} 
    ob[ ff ]=val
    suite( ob, ff )
}

export const suite_setob = (sid, ff, ob) => {
    let suite = suite_tourist(sid)
//console.log( 'suite_setob', ff, ob )    
    suite( ob, ff )
}


export const suite_getres = (sid) => {
    let suite = suite_tourist(sid)
    let res = suite.get()
    let { errorCount, warnCount, testCount, tests } = res
    let isValid = res.isValid()
    return { errorCount, warnCount, testCount, tests, isValid }
}
